import type { TRuleWithTheme } from '@ackee/fela';

import { ModalType } from './ModalType';

export const overlay: TRuleWithTheme<{ open: boolean }> = ({ theme, open }) => ({
    background: theme.colors.modalOverlay,
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    overflowY: 'auto',
    zIndex: 13,
    display: 'grid',
    placeItems: 'center',

    animationDuration: '200ms',
    animationTimingFunction: 'ease-in-out',

    animationName: {
        from: {
            opacity: 0,
        },
        to: {
            opacity: 1,
        },
    },

    ...(open === false && {
        animationName: {
            from: {
                opacity: 1,
            },
            to: {
                opacity: 0,
            },
        },
    }),
});

export const content: TRuleWithTheme<{ type: ModalType; open: boolean }> = ({ type, open }) => ({
    animationDuration: type === ModalType.huge ? '500ms' : '200ms',
    animationTimingFunction: 'ease-in-out',

    animationName: {
        from: {
            opacity: 0,
            transform: 'translateY(50%)',
        },
        to: {
            opacity: 1,
            transform: 'translateX(0%)',
        },
    },

    ...(open === false && {
        animationName: {
            from: {
                opacity: 1,
                transform: 'translateX(0%)',
            },
            to: {
                opacity: 0,
                transform: 'translateY(50%)',
            },
        },
    }),
});
